<mat-card class="default-card grid-all">
    <mat-card-header>
        <mat-card-title>{{ title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            @if (data.mode !== FormMode.Creation) {
                <div class="form-item">
                    <mat-form-field class="mat-form-field-name">
                        <mat-label>Id</mat-label>
                        <input matInput [formControl]="idFormControl" [(ngModel)]="data.record.id" autocomplete="off" />
                    </mat-form-field>
                </div>
            }
            <div class="form-item">
                <mat-form-field class="mat-form-field-name">
                    <mat-label>Nom</mat-label>
                    <input matInput [formControl]="nameFormControl" [(ngModel)]="data.record.name" autocomplete="off" required />
                    @if (nameFormControl?.errors?.required && (nameFormControl?.dirty || nameFormControl.touched)) {
                        <mat-error>Le champ 'Nom' est obligatoire.</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="form-item">
                <mat-form-field class="mat-form-field-name">
                    <mat-label>Ordre</mat-label>
                    <input matInput [formControl]="orderFormControl" [(ngModel)]="data.record.order" autocomplete="off" />
                </mat-form-field>
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" [ngClass]="{ hidden: data.mode === FormMode.Reading }" (click)="cancel()">Annuler</button>
        @if (data.mode !== FormMode.Reading) {
            <button mat-raised-button class="accent-button" [mat-dialog-close]="data.record" [disabled]="!isValid">Enregistrer</button>
        } @else {
            <button mat-raised-button class="accent-button" (click)="cancel()">Ok</button>
        }
    </mat-card-actions>
</mat-card>
